import { StyledFlag } from 'components/shared/BadgeFlag.styled';
import styled from 'styled-components';
import {
  color,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from '../../../../theme';
import { StyledDesc } from '../ClasicCVCard.styled';

export const StyledCard = styled.div`
  margin-bottom: ${spacing('xl')};
  border-radius: ${radius('lg')};
  border: 1px solid ${color('midnight_200')};

  @media (min-width: ${screen('md')}) {
    display: grid;
    grid-template-columns: 16rem 1fr;
  }

  @media (min-width: ${screen('lg')}) {
    grid-template-columns: 20rem 1fr;
  }
`;

export const StyledLogo = styled.div`
  background-color: ${color('midnight_100')};
  padding: ${spacing('xl')} ${spacing('lg')} ${spacing('lg')};
  border-top-left-radius: ${radius('lg')};
  border-top-right-radius: ${radius('lg')};
  border-bottom: 1px solid ${color('midnight_200')};

  @media (min-width: ${screen('md')}) {
    border-bottom-left-radius: ${radius('lg')};
    border-top-right-radius: 0;
    padding: ${spacing('lg')} ${spacing('md')} ${spacing('lg')} ${spacing('xl')};
    border-bottom: 0;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin-top: ${spacing('lg')};

    @media (min-width: ${screen('md')}) {
      margin-top: ${spacing('xl')};
    }
  }
`;

export const StyledHighlightImage = styled.div`
  margin-top: -${spacing('xl')};
  margin-left: -${spacing('lg')};
  margin-right: -${spacing('lg')};
  margin-bottom: ${spacing('xl')};
  border-top-right-radius: ${radius('lg')};
  overflow: hidden;

  @media (min-width: ${screen('md')}) {
    margin-top: -${spacing('lg')};
    margin-left: -${spacing('xl')};
    margin-right: -${spacing('md')};
    margin-bottom: ${spacing('lg')};

    border-top-right-radius: 0;
  }

  img {
    width: 100%;
    max-width: unset !important;
    margin-top: 0;
  }
`;

export const StyledFlagContainer = styled.div`
  position: relative;
  ${StyledFlag} {
    position: absolute;
    top: -${spacing('xl')};
    left: -${spacing('lg')};
    transform: translateY(-50%);

    @media (min-width: ${screen('md')}) {
      top: -${spacing('lg')};
      left: -${spacing('xl')};
    }
  }
`;

export const StyledContent = styled.div`
  padding: ${spacing('lg')};

  @media (min-width: ${screen('md')}) {
    border-left: 1px solid ${color('midnight_200')};
    padding: ${spacing('xl')};
  }

  ${StyledDesc} {
    padding-top: 0;
  }
`;

export const StyledTitle = styled.h4`
  font-size: ${fontSize('lg')};
  line-height: 1.2;
  font-weight: ${fontWeight('black')};
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl')};
    line-height: 1.16;
  }
`;

export const StyledCompany = styled.div`
  margin-top: ${spacing('xs')};
  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('medium')};
`;

export const StyledExtraContent = styled.div`
  overflow: hidden;
  margin: 0;
  transition: max-height 0.3s ease-in-out;
  max-height: 0;

  &.is-active {
    max-height: var(--content-height);
  }
`;

export const StyledLink = styled.div`
  border-top: 1px solid ${color('midnight_200')};
  margin-top: ${spacing('sm')};
  padding-top: ${spacing('sm')};
  font-size: ${fontSize('sm')};
  line-height: 1.14;
  display: flex;
  gap: ${spacing('xs')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('md')};
    line-height: 1.25;
  }

  a {
    font-weight: ${fontWeight('extraBold')};
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-break: break-word;
  }
`;
